import React from 'react'
import PropTypes from 'prop-types'

import {
  Box, Button, Form, SidebarModalListItem,
} from '@domain-group/suit-theme'

import { stringToKey } from '@domain-group/javascript-utils'

import useCustomFieldOptionValues from '../../hooks/useCustomFieldOptionValues'

const FieldOptionValues = (props) => {
  const { callbacks: { setEntityState }, options } = props

  const {
    callbacks: { setState, toggleOptionValues },
    fieldKey,
    fieldLabel,
    hasOptionValues,
    optionValueExists,
    optionValues,
  } = useCustomFieldOptionValues(options, { setEntityState })

  return (
    <>
      <Box
        border="1px solid"
        borderColor="lineColor"
        borderRadius={5}
        flexDirection="column"
        marginBottom={hasOptionValues ? 0 : 'medium'}
        marginTop="large"
        padding="large"
      >
        <Box flexDirection="column">
          <Form.Field boxProps={{ marginBottom: 'large' }} label="Label">
            <input
              onChange={e => setState({ fieldLabel: e.target.value })}
              onBlur={e => setState({ fieldKey: stringToKey(e.target.value) })}
              type="text"
              value={fieldLabel}
            />
          </Form.Field>

          <Form.Field boxProps={{ marginBottom: 'large' }} label="Key">
            <input onChange={e => setState({ fieldKey: e.target.value })} type="text" value={fieldKey} />
          </Form.Field>

          <Button
            buttonStyle="ghostCreate"
            disabled={optionValueExists}
            onClick={() => toggleOptionValues(fieldKey, fieldLabel)}
            size="medium"
            style={{ width: 'auto' }}
          >
            {optionValueExists ? 'Value Already Exists' : 'Add Value'}
          </Button>
        </Box>
      </Box>

      {hasOptionValues && (
        <Form.Field label="Option Values" marginTop="large">
          <Box flexDirection="column">
            {optionValues.map(option => (
              <SidebarModalListItem title={option.value}>
                <SidebarModalListItem.TertiaryText>{option.key}</SidebarModalListItem.TertiaryText>

                <SidebarModalListItem.Actions>
                  <SidebarModalListItem.Icon
                    onClick={() => toggleOptionValues(option.key, option.value)}
                    type="delete"
                  />
                </SidebarModalListItem.Actions>
              </SidebarModalListItem>
            ))}
          </Box>
        </Form.Field>
      )}
    </>
  )
}

FieldOptionValues.propTypes = {
  callbacks: PropTypes.shape({
    setEntityState: PropTypes.func.isRequired,
  }),
  options: PropTypes.object.isRequired,
}

export default FieldOptionValues
